import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import ButtonCta from '@components/atoms/button-cta'
import useStyles from './page-break-cta.styles'

const PageBreakCta = (props) => {
  const {
    heading,
    subtitle,
    supportiveCopy,
    buttonLabel,
    buttonLink,
    lightVariant,
  } = props

  const styles = useStyles({ lightVariant })

  return (
    <div className={styles.pageBreakCta}>
      <Container>
        <Typography variant="h2" className={styles.titleContent}>
          {heading}
        </Typography>
        {subtitle && (
          <Typography variant="h5" className={styles.subtitle}>
            {subtitle}
          </Typography>
        )}
        <Typography variant="body1" className={styles.descriptionContent}>
          {supportiveCopy}
        </Typography>

        <Grid container justifyContent="center" spacing={2}>
          <ButtonCta
            href={buttonLink}
            className={styles.buttonCta}
            variant={lightVariant ? 'contained' : 'outlined'}
            color="primary"
          >{buttonLabel}
          </ButtonCta>
        </Grid>
      </Container>
    </div>
  )
}

PageBreakCta.propTypes = {
  heading: PropTypes.string,
  subtitle: PropTypes.string,
  supportiveCopy: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonLink: PropTypes.string,
  lightVariant: PropTypes.bool,
}

PageBreakCta.defaultProps = {}

export default PageBreakCta
